<template>
  <div
    ref="fullLayoutRef"
    class="full-layout"
  >
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
// ============================================================================
// v2：高度改为「纯 CSS 撑满」，删除原先的 JS 测量（量 top → calc(100vh - top)）。
//
// 旧实现删掉的两个根因：
//   ① 非活动标签被 KeepAlive 移出文档（@vue/runtime-core 的 storageContainer 从不挂到
//      document），此时 getBoundingClientRect() 全为 0 → top 被写成 0 → height 变成
//      calc(100vh - 0px)，比正确值高出一整条 header + 多标签栏；
//   ② 靠 setTimeout(200) 猜「布局已稳定」，而会改动顶部高度的信号远不止 multiTab /
//      layout（还有 fixedHeader / multiTabFixed / splitMenus / device / 过渡动画时长），
//      且 onDeactivated 未清理定时器 → 200ms 内切页仍会写坏。
//
// 现在：.full-layout 绝对定位挂到直接父级 .ant-pro-basicLayout-content 上
//   （liyu-pc-lib/src/components/base-layouts/basic-layout.less 声明了
//    position: relative + margin: 24px 24px 0），沿用原来的 -24px 负 margin 抵消父级 margin。
//   几何与旧实现逐像素一致，但不再依赖任何测量时机。
//
// ★ 硬约束：直接父级必须是 position: relative（否则 containing block 退化为视口）。
// ============================================================================
import { provide, shallowRef } from 'vue';
import { FullLayoutState, fullLayoutStateSymbol } from './fullLayoutUtils';

const fullLayoutRef = shallowRef<HTMLElement | null>(null);
provide<FullLayoutState>(fullLayoutStateSymbol, {
  fullLayoutRef,
});
</script>
<style scoped lang="less">
.full-layout {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  // 负 margin 与 inset 叠加：盒子再向外扩 24px，用于抵消父级
  // .ant-pro-basicLayout-content 的 margin: 24px 24px 0。
  margin: -24px -24px 0px -24px;
  overflow: auto;
}
</style>
